<template>
    <div class="d-flex flex-column overflow-hidden h-100">
        <vue-custom-scrollbar
            class="app-content-padding flex-grow-1 overflow-hidden h-100"
        >
            <ts-page-title
                :title="$t('cashRequest.pageTitle')"
                :breadcrumb="[
                    { text: $t('home'), href: '/' },
                    {
                        text: $t('cashRequest.pageTitle'),
                        href: '/admin/cash-requests'
                    },
                    { text: $t('edit'), active: true }
                ]"
            />
            <div class="demo-spin-article">
                <ts-panel>
                    <ts-panel-wrapper>
                        <div class="tw-mb-4">
                            <span class="badge bg-secondary rounded-pill tw-text-sm">
                                {{ $t("cashRequest.requestNo") }}:
                                <strong>{{ model.request_no }}</strong>
                            </span>
                        </div>
                        <form-input
                            v-model="model"
                            :validate="errors"
                            :requested-by-name="requestedByName"
                            :currencies="currencies"
                            :banks="banks"
                        />
                    </ts-panel-wrapper>
                </ts-panel>
            </div>
        </vue-custom-scrollbar>

        <Spin size="large" fix v-if="loading"></Spin>

        <div
            id="footer"
            class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2"
            style="background-color: #e9ecef"
        >
            <ts-button
                @click.prevent="$router.push({ name: 'cash-request' })"
                class="btn-gray"
            >
                {{ $t("cancel") }}
            </ts-button>
            <ts-button
                color="primary"
                :waiting="waiting"
                :disabled="waiting"
                @click.prevent="onSave"
            >
                {{ $t("save") }}
            </ts-button>
        </div>
    </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import { isEmpty } from "lodash";
import FormInput from "./components/form-input.vue";
import moment from "moment";

export default {
    name: "CashRequestEdit",
    components: { FormInput },
    data() {
        return {
            loading: false,
            waiting: false,
            errors: new Errors(),
            model: {
                request_id: null,
                request_no: null,
                requested_by: null,
                request_date: null,
                request_amount: null,
                currency_id: null,
                bank_id: null,
                bank_account_no: "",
                bank_account_name: "",
                purpose: "",
                remark: ""
            }
        };
    },
    created() {
        AppOptions.appContentFullHeight = true;
        AppOptions.appContentClass = "p-0";
    },
    computed: {
        ...mapState("finance/cashRequest", ["edit_data", "currencies", "banks"]),
        requestedByName() {
            if (this.edit_data && this.edit_data.requested_by) {
                return this.edit_data.requested_by.employee_name_en;
            }
            const user = this.$store.state.authUser.user;
            return user && user.employee ? user.employee.employee_name_en : user.user_name;
        }
    },
    methods: {
        ...mapActions("finance/cashRequest", ["find", "getCurrencies", "getBanks"]),
        async fetchFormData() {
            this.loading = true;
            await this.getCurrencies();
            await this.getBanks();
            await this.find(this.$route.params.id);
            this.setEditData();
            this.loading = false;
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                this.model = {
                    request_id: this.edit_data.request_id,
                    request_no: this.edit_data.request_no,
                    requested_by: this.edit_data.requested_by
                        ? this.edit_data.requested_by.employee_id
                        : null,
                    request_date: this.edit_data.request_date
                        ? moment(this.edit_data.request_date).format("DD-MM-YYYY")
                        : null,
                    request_amount: this.edit_data.request_amount,
                    currency_id: this.edit_data.currency_id,
                    bank_id: this.edit_data.bank_id,
                    bank_account_no: this.edit_data.bank_account_no || "",
                    bank_account_name: this.edit_data.bank_account_name || "",
                    purpose: this.edit_data.purpose,
                    remark: this.edit_data.remark || ""
                };
            }
        },
        onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("finance/cashRequest/update", {
                    id: this.model.request_id,
                    data: this.model
                })
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    if (response.message_id == 0) {
                        this.$store.commit(
                            "finance/cashRequest/RESET_STATE"
                        );
                        this.$router.push({ name: "cash-request" });
                    }
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => (this.waiting = false));
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "CASH REQUEST",
                desc: not.text
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.fetchFormData());
    },
    beforeRouteLeave(to, from, next) {
        AppOptions.appContentFullHeight = false;
        AppOptions.appContentClass = "";
        this.$store.commit("finance/cashRequest/RESET_STATE");
        next();
    }
};
</script>
